import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TableContestMaintenance from "./components/table-contest-maintenance/TableContestMaintenance";

export function ContestMaintenancePage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableContestMaintenance />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
